import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { useNewClientContext } from 'Context/NewClientContext';
import { ClientNavCPC } from './ClientNavCPC';
import { ClientNavFoundationalOnly } from './ClientNavFoundationalOnly';

export const ClientNavPicker = (props) => {
  const { clientResource } = useNewClientContext();
  const Component = pick(clientResource, {
    [fr.relationships.foundationalOnly.name]: ClientNavFoundationalOnly,
  }, ClientNavCPC);
  return <Component {...props} />;
};
